jQuery(function($) {
	$('.navbar .dropdown').hover(function() {
		if ($(window).width() > 991 ) {
			$(this).find('.dropdown-menu').first().stop(true, true).delay(50).fadeIn();
		}

	}, function() {
		if ($(window).width() > 991 ) {
			$(this).find('.dropdown-menu').first().stop(true, true).delay(50).fadeOut();
		}
	});

	$('.navbar .dropdown > a').click(function(){
		if ($(window).width() > 991 ) {
			location.href = this.href;
		}
	});
});


// WEBPACK FOOTER //
// ./scripts/components/clickable-navbar-parent-link.js